// extracted by mini-css-extract-plugin
export default {"select":"Selector_select__kQTn1","descriptionDiv":"Selector_descriptionDiv__OdCvH","priceDiv":"Selector_priceDiv__qQ3IG"};